<template>
  <div v-if="recapData" class="vx-row mb-5">
    <div class="vx-col w-1/2 md:w-1/2">
      <vx-card class="overflow-hidden">
        <div slot="no-body">
          <div class="p-6 text-center">
            <feather-icon icon="UserCheckIcon" class="p-3 inline-flex rounded-full text-success" ></feather-icon>
            <div class="truncate">
              <h2 class="mb-1 font-bold mb-2 text-success">{{recapData.total_present}}</h2>
              <span class="text-black">Hadir</span>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <div class="vx-col w-1/2 md:w-1/2">
      <vx-card class="overflow-hidden">
        <div slot="no-body">
          <div class="p-6 text-center">
            <feather-icon icon="UserXIcon" class="p-3 inline-flex rounded-full text-danger"></feather-icon>
            <div class="truncate">
              <h2 class="mb-1 font-bold mb-2 text-danger">{{recapData.total_absence}}</h2>
              <span class="text-black">Tidak Hadir</span>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <!-- <div class="vx-col w-1/2 md:w-1/5">
      <vx-card class="overflow-hidden">
        <div slot="no-body">
          <div class="p-6 text-center">
            <feather-icon icon="CheckCircleIcon" class="p-3 inline-flex rounded-full text-success" ></feather-icon>
            <div class="truncate">
              <h2 class="mb-1 font-bold mb-2 text-success">{{recapData.total_ontime}}</h2>
              <span class="text-black">Datang Tepat Waktu</span>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <div class="vx-col w-1/2 md:w-1/5">
      <vx-card class="overflow-hidden">
        <div slot="no-body">
          <div class="p-6 text-center">
            <feather-icon icon="XCircleIcon" class="p-3 inline-flex rounded-full text-primary" ></feather-icon>
            <div class="truncate">
              <h2 class="mb-1 font-bold mb-2 text-primary">{{recapData.total_late}}</h2>
              <span class="text-black">Terlambat</span>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <div class="vx-col w-1/2 md:w-1/5">
      <vx-card class="overflow-hidden">
        <div slot="no-body">
          <div class="p-6 text-center">
            <feather-icon icon="AlertCircleIcon" class="p-3 inline-flex rounded-full text-primary"></feather-icon>
            <div class="truncate">
              <h2 class="mb-1 font-bold mb-2 text-primary">{{recapData.total_early}}</h2>
              <span class="text-black">Pulang Lebih Awal</span>
            </div>
          </div>
        </div>
      </vx-card>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    recapData: {
      type: Object,
      required: true
    }
  },
};
</script>